import { render, staticRenderFns } from "./scrollable-block.vue?vue&type=template&id=68dd56dd"
import script from "./scrollable-block.vue?vue&type=script&lang=js"
export * from "./scrollable-block.vue?vue&type=script&lang=js"
import style0 from "./scrollable-block.vue?vue&type=style&index=0&id=68dd56dd&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68dd56dd')) {
      api.createRecord('68dd56dd', component.options)
    } else {
      api.reload('68dd56dd', component.options)
    }
    module.hot.accept("./scrollable-block.vue?vue&type=template&id=68dd56dd", function () {
      api.rerender('68dd56dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/scrollable-block.vue"
export default component.exports